/* eslint-disable no-nested-ternary */
import React, { Fragment, useState } from "react";
import "../documentation.css";
import { formatTimestamp } from "../helpers";
import { DoneIcon, TodoIcon } from "../../assets/Icons";
import sopsObj from "./sopsObj";
import oldSOPsObj from "./oldSOPsObj";
import CandImage from "../Components/CandImage";
import Initials from "../Components/Initials";

const Spinner = () => (
  // not the same as the spinner in bookings
  <svg
    width="31"
    height="31"
    style={{ marginLeft: "32px" }}
    viewBox="0 0 38 38"
    stroke="#5e7fcc"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth="2">
        <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 18 18"
            to="360 18 18"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </g>
  </svg>
);

const KingspanDocuments = ({
  candidates,
  approverEmail,
  sops,
  readingList,
  images,
  passImage,
  handleOverlay,
  signDocOff,
  getReadingListPdf,
  downloadRef
}) => {
  const [selected, setSelected] = useState(null);
  const [lineSelected, setLineSelected] = useState();
  const [selectedDocName, setSelectedDocName] = useState();
  const [tempSignedDocs, setTempSignedDocs] = useState({});
  const [tempSignedCount, setTempSignedCount] = useState({});
  const [highlightBtn, setHighlightBtn] = useState("");

  const candidateSops = sops || {};

  const handleDownloadForm = candidate => {
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName
    );
  };

  const handleDownloadLiteracyTest = candidate => {
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName,
      "YKN1"
    );
  };

  const isDrugAndPolicyRead = c =>
    c.documents &&
    c.documents.readings &&
    c.documents.readings["drug-and-alcohol-policy-agency-workers-v2.pdf"] ? (
      <div className="tooltip">
        <button
          onClick={() => handleDownloadForm(c)}
          style={{
            fontSize: "14px",
            backgroundColor: "white",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #2196f3"
          }}
        >
          Download
        </button>
        <div className="tooltiptext">
          Signed{" "}
          {formatTimestamp(
            c.documents.readings[
              "drug-and-alcohol-policy-agency-workers-v2.pdf"
            ]
          )}
        </div>
      </div>
    ) : (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );

  const isLiteracyTestCompleted = c =>
    c.nonReadingListDocs && c.nonReadingListDocs.YKN1 ? (
      <button
        onClick={() => handleDownloadLiteracyTest(c)}
        style={{
          fontSize: "14px",
          backgroundColor: "white",
          padding: "8px",
          borderRadius: "5px",
          border: "1px solid #2196f3"
        }}
      >
        Download
      </button>
    ) : (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );

  const isRead = (c, r) => {
    if (c.documents && c.documents.readings && c.documents.readings[r]) {
      return (
        <div className="tooltip">
          <DoneIcon />
          <div className="tooltiptext">
            Signed {formatTimestamp(c.documents.readings[r])}
          </div>
        </div>
      );
    }
    return (
      <div className="tooltip">
        <TodoIcon />
      </div>
    );
  };

  const ViewButton = ({ id, fn, num }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-content-center tw-flex-1 tw-py-10">
      <button
        className={`${id === highlightBtn &&
          "tw-border-blue-400 tw-text-white tw-bg-blue-400 tw-border-2"} tw-bg-blue-200' tw-bg-blue-100 tw-p-2 lg:tw-w-3/4 tw-w-full tw-rounded-lg ${id !==
          highlightBtn &&
          "hover:tw-bg-blue-200 hover:tw-border-blue-500"} tw-border-blue-300 tw-border-2 tw-cursor-pointer`}
        onClick={fn}
      >
        <span className="md:tw-inline tw-hidden">View</span>
        <span className="md:tw-hidden tw-inline">{num}</span>
      </button>
    </div>
  );

  const SOPS = sopsObj;
  const oldSOPS = oldSOPsObj;

  const getDocCount = (line, candidateRef) => {
    const values = Object.values(SOPS[line]);

    if (!values) return undefined;
    let readCount = 0;
    let signedCount = 0;

    values.forEach(row => {
      const { id } = row;
      const read =
        candidateSops[candidateRef] &&
        candidateSops[candidateRef][lineSelected] &&
        candidateSops[candidateRef][lineSelected][id];
      const signed =
        candidateSops[candidateRef] &&
        candidateSops[candidateRef][lineSelected] &&
        candidateSops[candidateRef][lineSelected][`${id}_SIGNED`];
      if (read) readCount += 1;
      if (signed) signedCount += 1;
    });
    if (
      tempSignedCount[lineSelected] &&
      tempSignedCount[lineSelected][candidateRef]
    )
      signedCount = tempSignedCount[lineSelected][candidateRef];
    return { readCount, signedCount };
  };

  const canSignoffSOP = () => {
    // determine the email domain
    const currentUserDomain = approverEmail.split("@")[1];
    // only 'kingspan.com' users have permissions to sign a SOP off
    return currentUserDomain === "kingspan.com";
  };

  const FileContainer = ({
    docName,
    title,
    read = false,
    signed = false,
    readTimestamp = "",
    signedTimestamp = new Date().toISOString(),
    candidateRef,
    approver = "",
    isDisabled = true
  }) => {
    const checkIfShowSignOff = line => {
      if (oldSOPS[line].includes(title)) {
        return <div />;
      }
      return (
        <div className="tooltip">
          <input
            type={"checkbox"}
            className="tw-w-6 tw-h-6 tw-my-1 cursor-pointer"
            disabled={isDisabled}
            onClick={async () => {
              setSelectedDocName(title);
              const success = await signDocOff(
                docName,
                lineSelected,
                candidateRef
              );
              if (success) {
                // if profile 5 succesfully signed doc off, store a record temporarily that this doc is signed off and then display the green tick
                setTempSignedDocs({
                  ...tempSignedDocs,
                  [`${lineSelected}-${title}`]: candidateRef
                }); // dont store date here store the person
                const copy = tempSignedCount;
                const { signedCount } = getDocCount(lineSelected, candidateRef);
                if (!copy[lineSelected])
                  copy[lineSelected] = {
                    [candidateRef]: signedCount + 1
                  };
                copy[lineSelected][candidateRef] = signedCount + 1;
                setTempSignedCount(copy);
              }
              setSelectedDocName("");
            }}
          />
          <div
            className="tooltiptext"
            style={{ textAlign: "left", paddingLeft: "7", width: "auto" }}
            hidden={false}
          >
            {`Sign off '${title}'`}
          </div>
        </div>
      );
    };

    return (
      <div className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center">
        <p className="tw-mb-1">{title}</p>
        <div
          className="tw-w-full tw-h-full tw-flex"
          style={{ alignItems: "end" }}
        >
          <div className="tw-flex-1 tw-flex-col tw-py-2">
            {read ? (
              <div className="tooltip">
                <DoneIcon />
                <div className="tooltiptext">
                  Read {formatTimestamp(readTimestamp)}
                </div>
              </div>
            ) : (
              <TodoIcon />
            )}
            <p className=""></p>
            <p className="tw-pt-2">Read</p>
          </div>
          {/* approverEmail */}
          <div className="tw-flex-1 tw-flex-col tw-items-between tw-py-2">
            {tempSignedDocs[`${lineSelected}-${title}`] &&
            tempSignedDocs[`${lineSelected}-${title}`] === candidateRef ? ( // handle the temporary version - the person who just aproved will be the email of the person currently logged in
              <div className="tooltip">
                <DoneIcon />
                <div
                  className="tooltiptext"
                  style={{
                    textAlign: "left",
                    paddingLeft: "7",
                    paddingRight: "3",
                    width: "auto"
                  }}
                >
                  Signed {approverEmail ? `by ${approverEmail} ` : ""}{" "}
                  {formatTimestamp(signedTimestamp)}
                </div>
              </div>
            ) : signed ? (
              <div className="tooltip">
                <DoneIcon />
                <div
                  className="tooltiptext"
                  style={{
                    textAlign: "left",
                    paddingLeft: "7",
                    paddingRight: "3",
                    width: "auto"
                  }}
                >
                  Signed {approver ? `by ${approver} ` : ""}{" "}
                  {formatTimestamp(signedTimestamp)}
                </div>
              </div>
            ) : selectedDocName === title ? (
              <Spinner />
            ) : (
              checkIfShowSignOff(lineSelected, signed)
            )}
            <p className=""></p>
            <p className="tw-pt-2">
              {oldSOPS[lineSelected].includes(title) && !signed
                ? "New version available"
                : "Signed"}
            </p>
          </div>
        </div>
      </div>
    );
  };
  const populateDropRow = (line, curPersonIndex, candidateRef) => {
    const values = SOPS[line];
    if (!values) return undefined;

    const output = values.map((row, i) => {
      const { id, title } = row;
      const read =
        candidateSops[candidateRef] &&
        candidateSops[candidateRef][lineSelected] &&
        candidateSops[candidateRef][lineSelected][id]; // current person, current line (docs) and current doc - if present they have read the document

      if (read) {
        //   TODO signed and approver always undefined, does not make any effect to the code below
        const signed =
          candidateSops[candidateRef] &&
          candidateSops[candidateRef][lineSelected] &&
          candidateSops[candidateRef][lineSelected][`${id}_SIGNED`];
        const approver =
          candidateSops[candidateRef] &&
          candidateSops[candidateRef][lineSelected] &&
          candidateSops[candidateRef][lineSelected][`${id}_SIGNED_APPROVER`];

        if (signed) {
          return (
            <FileContainer
              key={i}
              docName={id}
              title={title}
              read={read}
              readTimestamp={read}
              signed={true}
              signedTimestamp={signed}
              approver={approver}
              candidateRef={candidateRef}
              isDisabled={!canSignoffSOP()}
            />
          );
        }
        return (
          <FileContainer
            docName={id}
            title={title}
            read={read}
            readTimestamp={read}
            candidateRef={candidateRef}
            isDisabled={!canSignoffSOP()}
          />
        );
      }

      return (
        <FileContainer docName={id} title={title} candidateRef={candidateRef} />
      );
    });

    return output;
  };

  const Header = ({
    title,
    line,
    countObj = { readCount: 0, signedCount: 0 }
  }) => (
    <div className="tw-w-full tw-flex md:tw-flex-row tw-flex-col md:tw-justify-between tw-items-start md:tw-p-5 tw-p-3">
      <p className="md:tw-pl-2 tw-pl-0 tw-text-md tw-pb-2">{title}</p>
      <div className="tw-w-auto tw-flex md:tw-justify-between tw-mr-2">
        <span className="md:tw-pr-5 tw-pr-3">
          {countObj.signedCount}/{Object.values(SOPS[line]).length} signed off
        </span>
        <span>
          {countObj.readCount}/{Object.values(SOPS[line]).length} documents read{" "}
        </span>
      </div>
    </div>
  );

  const getSOPTitle = line => {
    if (line === "line1") return "Line 1 SOPs -";
    if (line === "line24") return "Line 2 & 4 SOPs -";
    if (line === "line3") return "Line 3 SOPs -";
    if (line === "shop1") return "Shop 1 SOPs -";
    return "";
  };

  const setState = (i, line) => {
    if (selected === i && line === lineSelected) {
      setSelected(null);
      setLineSelected(null);
    } else {
      setSelected(i);
      setLineSelected(line);
    }
  };

  const setHighligtning = key =>
    highlightBtn === key ? setHighlightBtn("") : setHighlightBtn(key);

  return (
    <div>
      <div className="tw-rounded-md tw-overflow-x-auto ">
        <div className="tw-align-middle tw-rounded-md tw-inline-block tw-min-w-full">
          <div className="tw-shadow tw-rounded-md tw-overflow-hidden tw-border-b tw-border-gray-200 ">
            <table className="tw-overflow-x tw-border-collapse tw-min-w-full tw-border-2 tw-border-gray-500 tw-rounded-md tw-mb-8 tw-divide-y tw-divide-gray-200">
              <thead className="tw-border-collapse tw-bg-gray-50 tw-rounded-md tw-border-0 tw-border-gray-500 ">
                <tr>
                  <th
                    scope="tw-col"
                    style={{ width: "25%" }}
                    className="tw-py-4 tw-px-2 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    Worker
                  </th>
                  {readingList.map(doc => (
                    <th
                      key={doc.name}
                      scope="col"
                      className="tw-py-4 tw-px-2 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                    >
                      {doc.name}
                    </th>
                  ))}
                  <th
                    scope="col"
                    className="tw-py-4 tw-px-2 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    Literacy Test
                  </th>

                  <th
                    key="sops"
                    scope="col"
                    className="tw-w-full tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    <div className="tw-flex tw-flex-col tw-min-h-full tw-border-black">
                      <span className="tw-p-5">
                        {" "}
                        Standard Operating Procedure (SOPs){" "}
                      </span>
                      <div className="tw-min-w-full tw-h-14 tw-w-full tw-flex tw-border-t-2 tw-border-gray-500 ">
                        <p className="tw-flex-1 sm:tw-pt-3 tw-pt-0 tw-border-r-2 tw-border-gray-500">
                          Line 1
                        </p>
                        <p className="tw-flex-1 sm:tw-pt-3 tw-pt-0 tw-border-r-2 tw-border-gray-500">
                          Line 2 & 4
                        </p>
                        <p className="tw-flex-1 sm:tw-pt-3 tw-pt-0 tw-border-r-2 tw-border-gray-500">
                          Line 3
                        </p>
                        <p className="tw-flex-1 sm:tw-pt-3 tw-pt-0">Shop 1</p>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                {candidates.map((c, i) => (
                  <Fragment key={i}>
                    <tr className="reading-list__rows">
                      <td className="tw-text-sm">
                        <div className="tw-flex lg:tw-flex-row tw-flex-col tw-w-full lg:tw-items-center md:tw-text-left tw-text-center">
                          {images && images[c.candidateRef] ? (
                            <CandImage
                              handleOverlay={handleOverlay}
                              passImage={passImage}
                              image={images[c.candidateRef]}
                              firstName={c.firstName}
                            />
                          ) : (
                            <Initials
                              firstName={c.firstName}
                              lastName={c.lastName}
                            />
                          )}
                          <p className="tw-font-bold tw-font-lg lg:tw-pl-0 tw-pl-1">
                            {c.firstName} {c.lastName}
                          </p>
                        </div>
                      </td>
                      {readingList.map((r, index) => (
                        <td className="tw-p-2" key={`th${index}`}>
                          {" "}
                          {r.filename ===
                          "drug-and-alcohol-policy-agency-workers-v2.pdf"
                            ? isDrugAndPolicyRead(c)
                            : isRead(c, r.filename)}{" "}
                        </td>
                      ))}
                      <td className="tw-p-2">{isLiteracyTestCompleted(c)}</td>
                      <td>
                        <div
                          className={`tw-flex tw-min-h-full tw-w-full tw-min-w-fit`}
                        >
                          <ViewButton
                            id={`${i}${c.lastName}L1`}
                            fn={() => {
                              setState(i, "line1");
                              setHighligtning(`${i}${c.lastName}L1`);
                            }}
                            num="L1"
                          />
                          <ViewButton
                            id={`${i}${c.lastName}L2`}
                            fn={() => {
                              setState(i, "line24");
                              setHighligtning(`${i}${c.lastName}L2`);
                            }}
                            num="L2"
                          />
                          <ViewButton
                            id={`${i}${c.lastName}L3`}
                            fn={() => {
                              setState(i, "line3");
                              setHighligtning(`${i}${c.lastName}L3`);
                            }}
                            num="L3"
                          />
                          <ViewButton
                            id={`${i}${c.lastName}S1`}
                            fn={() => {
                              setState(i, "shop1");
                              setHighligtning(`${i}${c.lastName}S1`);
                            }}
                            num="S1"
                          />
                        </div>
                      </td>
                    </tr>
                    {selected === i ? (
                      <tr>
                        <td colSpan="12">
                          <Header
                            line={lineSelected}
                            title={`${getSOPTitle(lineSelected)} ${
                              c.firstName
                            } ${c.lastName}`}
                            countObj={getDocCount(lineSelected, c.candidateRef)}
                          />
                          <div className="tw-flex tw-min-w-full tw-overflow-y-auto tw-flex-wrap tw-pb-4 tw-px-0 tw-justify-center tw-items-center">
                            {/* TODO Pass here all the sops the person has using timestamp to show what is read + signed */}
                            {populateDropRow(lineSelected, i, c.candidateRef)}
                          </div>
                        </td>
                      </tr>
                    ) : null}
                  </Fragment>
                ))}
              </tbody>
            </table>
            <a className="d-none" ref={downloadRef}></a>
          </div>
        </div>
      </div>
      <a className="d-none" ref={downloadRef}></a>
    </div>
  );
};

export default KingspanDocuments;
